import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

export function RestrictSurveyEditor({ children }: { children: ReactNode }) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.SurveysEditing]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
